export default __webpack_public_path__ + "static/media/logo_h.b0b2b671.svg";